import RouterUtils from '../../../../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class CompanyUpdateRequest {

    // CompanySave {
    //   id: number
    //   name: string
    //   nif: string
    //   contact_person: string
    //   phone: string
    //   email: string
    //   address: string
    //   ccc: string
    //   disabled: string
    //   document_schema_id: number
    //   document_schema_monthly_id: number
    //   user_email: string
    //   user_plain_password: string
    //   user_password: string
    // }

    _id; // number
    _name; // string
    _nif; // string
    _phone; // string
    _ccc; // string
    _contactPerson; // string
    _email; // string
    _address; // string

    constructor(values, company) {
        this._id = company.id();
        this._name = values.name;
        this._nif = values.nif;
        this._phone = values.phone;
        this._ccc = values.ccc;
        this._contactPerson = values.contactPerson;
        this._email = values.email;
        this._address = values.address;
    }

    url() {
        return RouterUtils.generateRoute(ApiEndpoints.COMPANY_ID, { id: this._id });
    }

    body() {
        return {
            id: this._id,
            name: this._name,
            nif: this._nif,
            contact_person: this._contactPerson,
            phone: this._phone,
            email: this._email,
            address: this._address,
            ccc: this._ccc,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/update/company-update/CompanyUpdateRequest.js